<template>
  <div class="FlexGridCell"
    :class="classes">

    <slot></slot>

  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String
    }
  },

  computed: {
    classes () {
      const classes = []
      if (this.size) classes.push(`FlexGridCell--size${this.size}`)
      return classes
    }
  }
}
</script>

<style>
@import 'properties';

.FlexGridCell {
  position: relative;
}

.FlexGridCell--size1of1,
.FlexGridCell--size2of2,
.FlexGridCell--size3of3,
.FlexGridCell--size4of4 {
  width: 100%;
}

.FlexGridCell--size1of4 {
  width: 50%;

  @media (min-width: 600px) {
    width: 25%;
  }
}

.FlexGridCell--size1of2,
.FlexGridCell--size2of4 {
  width: 100%;

  @media (min-width: 600px) {
    width: 50%;
  }
}

.FlexGridCell--size3of4 {
  width: 100%;

  @media (min-width: 600px) {
    width: 75%;
  }
}

.FlexGridCell--size1of3 {
  width: 100%;

  @media (min-width: 600px) {
    width: 33.3333%;
  }
}

.FlexGridCell--size2of3 {
  width: 100%;

  @media (min-width: 600px) {
    width: 66.6666%;
  }
}
</style>



// WEBPACK FOOTER //
// FlexGridCell.vue?0dbcc752